import useAppLocation from './useAppLocation';

export default function useGetBaseUrl() {
  const location = useAppLocation();

  return location === 'NL' ? '/nederland' : '/belgie';
}
